module.exports = __webpack_public_path__ + "img/Weapon_106.dd1cae97.png";